import React from 'react';
import { motion } from 'framer-motion';

const PageHero = ({ title, highlight, subtitle, pattern = 'dots' }) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-secondary-800 via-secondary-900 to-dark-50 dark:from-dark-100 dark:via-dark-50 dark:to-dark-100">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.04]">
        {pattern === 'dots' && (
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
              backgroundSize: '24px 24px',
            }}
          />
        )}
        {pattern === 'grid' && (
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
              backgroundSize: '40px 40px',
            }}
          />
        )}
      </div>
      {/* Accent glow */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-primary-500 rounded-full blur-[140px] opacity-10" />
      <div className="absolute bottom-0 left-0 w-56 h-56 bg-accent-500 rounded-full blur-[120px] opacity-10" />

      <div className="relative container-custom py-14 md:py-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
            {title}{' '}
            {highlight && (
              <span className="bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent">
                {highlight}
              </span>
            )}
          </h1>
          {subtitle && (
            <p className="text-base md:text-lg text-secondary-300 leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
